
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/devices/[[...device]]",
      function () {
        return require("private-next-pages/devices/[[...device]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/devices/[[...device]]"])
      });
    }
  